/**
 * @generated SignedSource<<3fb58c950f3b1751cbefd015bbcf568e>>
 * @relayHash ada3e04d4a67a0cf753a63d3ffc29f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70

import type { ConcreteRequest } from 'relay-runtime';
export type navigationBridgeMethod_tenantUrlQuery$variables = {
  cloudIds?: ReadonlyArray<string> | null | undefined;
};
export type navigationBridgeMethod_tenantUrlQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null | undefined;
  } | null | undefined> | null | undefined;
};
export type navigationBridgeMethod_tenantUrlQuery = {
  response: navigationBridgeMethod_tenantUrlQuery$data;
  variables: navigationBridgeMethod_tenantUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "navigationBridgeMethod_tenantUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "navigationBridgeMethod_tenantUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70",
    "metadata": {},
    "name": "navigationBridgeMethod_tenantUrlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "537ee6daeedfde6695ff904bf976af02";

export default node;
